import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Heading, Text } from '../../Elements/Elements';

import { textToDate } from 'utils/common';

import classes from './TextChart.module.scss';

const TextChart = ({
  data: { title, contentText, nextDate, message, warning }
}) => {
  const { t } = useTranslation(['activity']);
  return (
    <section className={classes.box}>
      <Heading>{title}</Heading>
      <Text className={classes.content} weight="b">
        {contentText}
      </Text>
      <Text className={classes.padding}>{message}</Text>
      <Text size={4} weight="b">
        {nextDate &&
        nextDate !== '-' &&
        nextDate !== 'NA' &&
        nextDate !== '1970-01-01T00:00:00.000Z'
          ? textToDate(nextDate)
          : 'NA'}
      </Text>
      {warning && (
        <Text weight="b" className={classes.warning}>
          {t('activity:customers.DUE_TO_BE_CANCELED')}
        </Text>
      )}
    </section>
  );
};

TextChart.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    contentText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
    nextDate: PropTypes.any,
    warning: PropTypes.bool
  })
};

export default TextChart;
